import PropTypes from 'prop-types';
import 'react';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    alignItems: PropTypes.oneOf([
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'baseline',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    flexWrap: PropTypes.oneOf([
        'nowrap',
        'wrap',
        'wrap-reverse',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    flexDirection: PropTypes.oneOf([
        'row',
        'row-reverse',
        'column',
        'column-reverse',
        'inherit',
        'initial',
        'revert',
        'unset'
    ]),
    justifyContent: PropTypes.oneOf([
        'stretch',
        'center',
        'start',
        'end',
        'flex-start',
        'flex-end',
        'left',
        'right',
        'normal',
        'space-between',
        'space-around',
        'space-evenly',
        'inherit',
        'initial',
        'revert',
        'unset'
    ])
};
const FlexBox = createComponent({
    displayName: 'FlexBox',
    root: 'div',
    propTypes,
    propConfig: {
        classNames: [
            'swan-display-flex'
        ],
        processProps (_param) {
            var { style ={} , alignItems , flexWrap , flexDirection , justifyContent  } = _param, props = _object_without_properties(_param, [
                "style",
                "alignItems",
                "flexWrap",
                "flexDirection",
                "justifyContent"
            ]);
            return _object_spread_props(_object_spread({}, props), {
                style: _object_spread_props(_object_spread({}, style), {
                    alignItems: alignItems !== null ? alignItems : undefined,
                    flexWrap: flexWrap !== null ? flexWrap : undefined,
                    flexDirection: flexDirection !== null ? flexDirection : undefined,
                    justifyContent: justifyContent !== null ? justifyContent : undefined
                })
            });
        }
    }
});

export { FlexBox };
